import { render } from "./SkeletonProductTile.vue?vue&type=template&id=d8e3cb98&scoped=true"
import script from "./SkeletonProductTile.vue?vue&type=script&lang=js"
export * from "./SkeletonProductTile.vue?vue&type=script&lang=js"

import "./SkeletonProductTile.vue?vue&type=style&index=0&id=d8e3cb98&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8e3cb98"]])

export default __exports__